module.exports = __webpack_public_path__ + "static/media/Call-Square.62b22e2d.jpg";